import { TaskFilter, OperationTaskList } from '../../../services/types/OperationTask';
import { Action, ApiState } from '../../../types';
import { callService, serviceReducer } from '../../../shared/hooks/serviceReducer';

export type OperDocumentAction =
  | Action<OperationTaskList, TaskFilter>
  | { type: 'PAGE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<OperationTaskList, TaskFilter>,
  action: OperDocumentAction
): ApiState<OperationTaskList, TaskFilter> => {
  switch (action.type) {
    case 'PAGE':
      return callService(state, { ...state.filter, pageNumber: action.value });
    case 'ORDER':
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        sortField: action.column,
        sortDescending: action.descending,
      });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
